module.exports = __webpack_public_path__ + "static/media/iclusig-img1.bb7ccf88.PNG";